const Footer = () => {
    return (
        <div className="container-fluid d-flex justify-content-between">
            <nav className="pull-left">
                <ul className="nav">
                    <li className="nav-item">
                        <a className="nav-link" href="https://yourdomain.com" target="_blank" rel="noopener noreferrer">
                            Copyright © E-books Author Dashboard
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    );
}

export default Footer;